import _ from 'lodash'
import { ReservationStatusesEnums } from '../../components/shared/statustypes'

export const resStates = {
    new: {
      icon: "asterisk"
    },
    saving: {
      icon: "spinner"
    },
    error: {
      icon: "warning sign"
    },
    saved: {
      icon: "save outline"
    }
  }

export const isInactiveStatus = statusId =>
    statusId === ReservationStatusesEnums.Cancelled || statusId === ReservationStatusesEnums.Deleted

export const isInactiveReservation = r => isInactiveStatus(r?.Reservation?.StatusId)

export const activeBlocks = reservations => _.filter(reservations, r => r.IsBlock && !isInactiveReservation(r))

// Group-level fields (agent, company, guest, ...) are read from and saved to this row
export const getMainBlock = reservations =>
    _.find(reservations, r => r.IsPrimaryReservationInGroup && !isInactiveReservation(r)) ||
    _.first(activeBlocks(reservations)) ||
    _.find(reservations, 'IsPrimaryReservationInGroup')

// Legacy and Classic-synced groups may have no IsBlock rows, so fall back to the primary's status
export const isCancelledGroup = reservations => {
    const blocks = _.filter(reservations, 'IsBlock')
    return blocks.length > 0
        ? _.every(blocks, isInactiveReservation)
        : isInactiveReservation(_.find(reservations, 'IsPrimaryReservationInGroup'))
}

// Cancelled blocks stay listed because Classic can leave their FITs active
export const isHiddenInActiveGroup = r =>
    isInactiveReservation(r) && !(r.IsBlock && r.Reservation.StatusId === ReservationStatusesEnums.Cancelled)

const SAVED_ID_KEYS = ['ID', 'Id', 'ReservationID', 'ReservationId']

// Child rows copied from another reservation must not carry its saved ids (UNIQUE violations on save)
export const withoutChildRowIds = reservation =>
    _.mapValues(reservation, value =>
        Array.isArray(value)
            ? value.map(item => (_.isPlainObject(item) ? _.omit(item, SAVED_ID_KEYS) : item))
            : value)
